module.exports = __webpack_public_path__ + "img/pla_MT.af636a39.png";